import React, { useState } from "react";

const KS2SectionASuspensionSaving = (props) => {
  const { kiviMemberNo, setSavingSuspensionData } = props;
  const [suspensionSaving, setSuspensionSaving] = useState("");

  const handleSavingSuspensionChange = (e) => {
    const value = e.target.value;
    setSuspensionSaving(value);
    setSavingSuspensionData(value);
  };

  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
        <div className="mb-3 number">2.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className=" col-md-5 yes-no-label">
              <label className="">Are you on a savings suspension?</label>
            </div>

            <div className="section-form-group yes-no-box col-md-7">
              <div className="section-form-group-inline pr-3">
                <div className="form-check form-check-inline mb-1">
                  <input
                    type="radio"
                    id="saving_suspension_yes"
                    name="savingSuspension"
                    value="yes"
                    checked={suspensionSaving === "yes"}
                    onChange={handleSavingSuspensionChange}
                    //className="form-check-input"
                    disabled={kiviMemberNo === "no"}
                    style={{ transform: "scale(1.5)", marginRight: "8px" }}
                  />
                  <label htmlFor="saving_suspension_yes" className="form-check-label mb-0">Yes. See note below</label>
                </div>
                <div className="form-check form-check-inline mb-1 ">
                  <input
                    type="radio"
                    id="saving_suspension_no"
                    name="savingSuspension"
                    value="no"
                    checked={suspensionSaving === "no"}
                    onChange={handleSavingSuspensionChange}
                    //className="form-check-input"
                    disabled={kiviMemberNo === "no"}
                    style={{ transform: "scale(1.5)", marginRight: "8px" }}
                  />
                  <label htmlFor="saving_suspension_no" className="form-check-label mb-0">No. Go to Question 4</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
};
export default KS2SectionASuspensionSaving;
